import EmptyStateBanner from './EmptyStateBanner';
import { EmptyStateBannerProps, EmptyStateBannerValueProps } from './types';

export type { EmptyStateBannerProps, EmptyStateBannerValueProps };
export default EmptyStateBanner;
